/*
* @author    Agence Dn'D <contact@dnd.fr>
* @license   https://opensource.org/licenses/osl-3.0.php  Open Software License (OSL 3.0)
* @link      https://www.dnd.fr/
*/

if (!customElements.get('product-tabs')) {
    const ProductTabs = class extends HTMLElement {
        constructor() {
            super();
            this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
            this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
            this.tabs.forEach((tab) => {
                tab.addEventListener('click', this.onTabClick.bind(this));
                tab.addEventListener('keydown', this.onTabKeydown.bind(this));
            });
        }

        /**
         * Handles 'click' events on a tab button.
         * @param {object} evt - Event object.
         */
        onTabClick(evt) {
            this.selectTab(evt.currentTarget);
        }

        /**
         * Handles 'keydown' events on a tab button for roving-tabindex keyboard navigation.
         * @param {object} evt - Event object.
         */
        onTabKeydown(evt) {
            const currentIndex = this.tabs.indexOf(evt.currentTarget);
            let newIndex = null;

            if (evt.key === 'ArrowRight') {
                newIndex = (currentIndex + 1) % this.tabs.length;
            } else if (evt.key === 'ArrowLeft') {
                newIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
            } else if (evt.key === 'Home') {
                newIndex = 0;
            } else if (evt.key === 'End') {
                newIndex = this.tabs.length - 1;
            } else {
                return;
            }

            evt.preventDefault();
            this.selectTab(this.tabs[newIndex]);
            this.tabs[newIndex].focus();
        }

        /**
         * Activates the given tab and its associated panel, deactivating the others.
         * @param {HTMLElement} selectedTab - The tab button to activate.
         */
        selectTab(selectedTab) {
            this.tabs.forEach((tab) => {
                const isSelected = tab === selectedTab;
                tab.setAttribute('aria-selected', isSelected);
                tab.tabIndex = isSelected ? 0 : -1;
            });

            this.panels.forEach((panel) => {
                panel.hidden = panel.id !== selectedTab.getAttribute('aria-controls');
            });
        }
    };

    window.customElements.define('product-tabs', ProductTabs);
}
